import { Component, OnInit, OnDestroy, NgZone, EventEmitter, Input } from '@angular/core';

import { Subscription } from 'rxjs';

import {
    AuthorizationService,
    Document,
    DocumentService,
    DataArray,
    Preset,
    AssociationService,
    PresetService
} from './../../../../shared/index';

@Component({
    selector: 'document-list',
    templateUrl: './document-list.html',
    standalone: false
})

export class DocumentListComponent implements OnInit, OnDestroy {
    @Input('association') association = false;
    @Input('showPresetOption') showPresetOption = false;
    public documents: DataArray<Document> = new DataArray<Document>(1);
    public filteredDocuments: Document[] = [];
    public filteredPresets: DataArray<Preset> = new DataArray<Preset>(1);
    public preset: Preset = new Preset();

    public viewHistory: EventEmitter<Document> = new EventEmitter<Document>();
    public processing = true;
    public isPreset = false;
    private filter = '';
    private subscriptions: Subscription[] = [];

    public ascending = true;
    public currentPage = 1;
    public total = 0;
    public filtered = false;

    public presetsTotal = 0;
    public presetsFiltered = false;

    constructor(
        private _ngZone: NgZone,
        private _documentService: DocumentService,
        private _authorizationService: AuthorizationService,
        private _associationService: AssociationService,
        private _presetService: PresetService
    ) {
        this.subscriptions.push(this._presetService.filteredPresetsChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.presetsTotal = this._presetService.totalPresets;
                this.filteredPresets = new DataArray<Preset>(1);
                for (const preset of info) {
                    this.filteredPresets.update(preset, true);
                }
                this.processing = false;
            });
        }));

        this.subscriptions.push(this._presetService.presetChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.presetsTotal = this._presetService.totalPresets;
                this.filteredPresets = new DataArray<Preset>(1);
                for (const preset of info) {
                    this.filteredPresets.update(preset, true);
                }
                this.processing = false;
            });
        }));

        this.subscriptions.push(this._presetService.beginFilter.subscribe((info: boolean) => {
            this._ngZone.run(() => {
                this.filteredPresets.init();
            });
        }));

    }

    ngOnInit(): void {
        this.documents.init();
        this.filteredPresets.init();
        this._presetService.getPresets();

        for (const document of this._documentService.documents.Data) {
            this.documents.update(document, true);
        }

        this.subscriptions.push(this._documentService.startSearch.subscribe((term: string) => {
            this.filter = term;
            this.filteredDocuments = this.documents.Data.filter((doc) => {
                return doc.FileName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
            });
        }));

        this.subscriptions.push(this._documentService.documentsChange.subscribe((documents: Document[]) => {
            this._ngZone.run(() => {
                this.total = this._documentService.totalDocuments;
                this.currentPage = this._documentService.currentPage;
            });
            if (!this.association) {
                this._ngZone.run(() => {
                    this.documents.init();
                    for (const document of documents) {
                        this.documents.update(document, true);
                    }
                    for (const document of this.documents.Data) {
                        for (const offset of [0, 1, 2, 3, 4]) {
                            this._documentService.hasMatch(offset, document.FileName).then((result: boolean) => {
                                document.Match[offset] = result ? 'fa-check' : 'fa-ban';
                                document.Color[offset] = result ? 'bg-success' : 'bg-danger';
                            });
                        }
                    }
                });
            } else {
                this.documents.init();
                for (const document of documents) {
                    this.documents.update(document, true);
                }

                this._ngZone.run(() => {
                    this.processing = false;
                    this.filteredDocuments = this.filter.length == 0 ? this.documents.Data : this.documents.Data.filter((doc) => doc.FileName.toLowerCase().indexOf(this.filter.toLowerCase()) > 1)
                });
            }
        }));

        if (this.association) {
            //removed 4/20/23 due to error of running out of memory when adding too many documents and/or removing document associations.
            //  all docuemnts in document-list were calling multiple functions and causing overflow
            //this.subscriptions.push(this._associationService.documentsAssociated.subscribe((result: boolean) => {
            //    for (let document of this.documents.Data) {
            //        this._documentService.getEquipmentCount(document.Id).then((result: number) => {
            //            document.EquipmentCount = result;
            //        });
            //    }
            //}));
            this.subscriptions.push(this._documentService.clearSelected.subscribe((result: boolean) => {
                for (const document of this.documents.Data.filter((doc) => {
                    return doc.Selected;
                })) {
                    document.Selected = false;
                }
                for (let i = 0; i < this.filteredPresets.Data.length; i++) {
                        this.filteredPresets.Data[i].Selected = false;
                    }
            }));
        }
        if (!this.association) {
            this.getPage(1);
        } else {
            this._documentService.getAllDocuments();
        }
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    public selectDocument(document: Document): void {
        document.Selected = !document.Selected;
        this._documentService.selectDocument(document);
    }

    public selectPreset(presetId: number): void {
        for (let i = 0; i < this.filteredPresets.Data.length; i++) {
            if (this.filteredPresets.Data[i].Id == presetId) {
                this.filteredPresets.Data[i].Selected = true;
            }
            else {
                this.filteredPresets.Data[i].Selected = false;
            }
        }
        this._presetService.selectPreset(presetId);
    }


    public togglePreset(): void {
        this._presetService.ResetPresetSelection();
        for (let i = 0; i < this.documents.Data.length; i++) {
            this.documents.Data[i].Selected = false;
        }

        this.isPreset = !this.isPreset;
    }

    getPage(page: number): void {
        this.currentPage = page;
        if (!this.association) {
            this.documents.init();
        }
        else {
            this._documentService.searchFileName = '';
        }
        this._documentService.getDocuments(page);
    }

    showHistory(document: Document): void {
        this.viewHistory.emit(document);
    }
}
